import { Component, inject } from  '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { CockpitDesignerStore } from '../cockpitDesigner.service';

@Component({
  selector: 'app-designer-row-editor',
  templateUrl: 'designer-row-editor.component.html',
  styleUrl: 'designer-row-editor.component.css',
  imports: [ MatButtonModule, MatIconModule, MatDividerModule ],
})

export class DesignerRowEditor {

  private readonly store = inject(CockpitDesignerStore);

  handleAddNewRowClick(event: MouseEvent){

    this.store.addNewRow()
  }

}